function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "m102.63 96-6.63 6.63v25.37h48v-25.37l-6.63-6.63z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "m144 230.63-6.63-6.63h-34.74l-6.63 6.63v25.37h48z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "m144 358.63-6.63-6.63h-34.74l-6.63 6.63v25.37h48z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "m496 48h-16v-32c0-8.837-7.163-16-16-16s-16 7.163-16 16v32h-32v-32c0-8.837-7.163-16-16-16s-16 7.163-16 16v32h-16c-8.84 0-16 7.16-16 16s7.16 16 16 16v39c0 22.06 17.94 40 40 40h8v129c0 44.11-35.89 80-80 80h-16v-320c0-26.47-21.53-48-48-48h-224c-26.47 0-48 21.53-48 48v416c0 26.47 21.53 48 48 48h224c26.47 0 48-21.53 48-48v-32c-7.61 0-61.425 0-68.3 0-5.54 9.56-15.89 16-27.7 16-17.64 0-32-14.36-32-32s14.36-32 32-32c11.81 0 22.16 6.44 27.7 16h84.3c61.76 0 112-50.24 112-112v-129h8c22.06 0 40-17.94 40-40v-39c8.84 0 16-7.16 16-16s-7.16-16-16-16zm-427.31 292.69 16-16c3-3 7.07-4.69 11.31-4.69h48c4.24 0 8.31 1.69 11.31 4.69l16 16c3 3 4.69 7.07 4.69 11.31v48c0 8.84-7.16 16-16 16h-80c-8.84 0-16-7.16-16-16v-48c0-4.24 1.69-8.31 4.69-11.31zm-4.69-68.69v-48c0-4.24 1.69-8.31 4.69-11.31l16-16c3-3 7.07-4.69 11.31-4.69h48c4.24 0 8.31 1.69 11.31 4.69l16 16c3 3 4.69 7.07 4.69 11.31v48c0 8.84-7.16 16-16 16h-80c-8.84 0-16-7.16-16-16zm112-128c0 8.84-7.16 16-16 16h-80c-8.84 0-16-7.16-16-16v-48c0-4.24 1.69-8.31 4.69-11.31l16-16c3-3 7.07-4.69 11.31-4.69h48c4.24 0 8.31 1.69 11.31 4.69l16 16c3 3 4.69 7.07 4.69 11.31zm64 208h-16c-8.84 0-16-7.16-16-16s7.16-16 16-16h16c8.84 0 16 7.16 16 16s-7.16 16-16 16zm0-64h-16c-8.84 0-16-7.16-16-16s7.16-16 16-16h16c8.84 0 16 7.16 16 16s-7.16 16-16 16zm0-64h-16c-8.84 0-16-7.16-16-16s7.16-16 16-16h16c8.84 0 16 7.16 16 16s-7.16 16-16 16z"
});

function Svg220(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "inherit",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg220);
export default __webpack_public_path__ + "static/media/2_20.6313e4e9.svg";
export { ForwardRef as ReactComponent };